import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  MobileNoWOValueValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import ShadowCard from "../../components/common/ShadowCard";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import {
  createCarrier,
  getCarrierByID,
  updateCarrier,
} from "./services/carrier.services";
import { clearCarrierDetails } from "./carrierSlice";
// import { getAllCountries } from "../country/services/country.services";
// import { ICity } from "../city/cityModel";
import FormSelectionField from "../../components/formFields/FormSelectionField";

// import { IState } from "../state/stateModel";
// import { ICountry } from "../country/countryModel";
import { STATUSARRAY } from "../../_contstants/common";
import { findIndex } from "lodash";
import { ICity } from "../city/cityModel";
import { IState } from "../state/stateModel";
import { ICountry } from "../country/countryModel";
import { findAllActiveCity } from "../city/services/city.services";
import { getAllActiveCountries } from "../country/services/country.services";
import { findAllActiveStates } from "../state/services/state.services";

interface CityChangeWatcherProps {
  formRenderProps: FormRenderProps;
  CityList: ICity[];
}

const CityChangeWatcher: React.FC<CityChangeWatcherProps> = ({
  CityList,
  formRenderProps,
}) => {
  const city_id = formRenderProps.valueGetter("city_id");

  useEffect(() => {
    const CityID = city_id ? city_id : undefined;
    const cityIndex = findIndex(CityList, { id: CityID });
    if (cityIndex > -1) {
      const city = CityList[cityIndex];
      formRenderProps.onChange("state_id", { value: city.state_id });
      formRenderProps.onChange("country_id", { value: city.country_id });
    } else {
      formRenderProps.onChange("city_id", { value: "" });
      formRenderProps.onChange("state_id", { value: "" });
      formRenderProps.onChange("country_id", { value: "" });
    }
  }, [city_id]);
  return null;
};

const CreateCarrier: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const carrier_guid = location.state?.carrier_guid;

  const CarrierDetail = useAppSelector((state) => state.carrier.CarrierDetail);
  const loading = useAppSelector((state) => state.carrier.loading);
  const CityList = useAppSelector((state) => state.city.CityList);
  const StateList = useAppSelector((state) => state.state.StateList);
  const CountryList = useAppSelector((state) => state.country.CountryList);

  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [CarrierDetail, CityList, StateList, CountryList]);

  useEffect(() => {
    if (carrier_guid) {
      dispatch(getCarrierByID(carrier_guid));
    }
    return () => {
      dispatch(clearCarrierDetails());
    };
  }, [carrier_guid]);

  useEffect(() => {
    dispatch(findAllActiveCity());
    dispatch(getAllActiveCountries());
    dispatch(findAllActiveStates());
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      if (carrier_guid) {
        const editPayload = {
          carrier_guid: carrier_guid,
          carrier_name: values.carrier_name ? values.carrier_name : "",
          city_id: values.city_id ? +values.city_id : null,
          state_id: values.state_id ? +values.state_id : null,
          country_id: values.country_id ? +values.country_id : null,
          contact_person: values.contact_person ? values.contact_person : "",
          mobile_number: values.mobile_number ? values.mobile_number : "",
          carrier_type: values.carrier_type ? values.carrier_type : "",
          address: values.address ? values.address : "",
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateCarrier(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate(-1);
        }
      } else {
        const insertPayload = {
          carrier_name: values.carrier_name ? values.carrier_name : "",
          city_id: values.city_id ? +values.city_id : null,
          state_id: values.state_id ? +values.state_id : null,
          country_id: values.country_id ? +values.country_id : null,
          contact_person: values.contact_person ? values.contact_person : "",
          mobile_number: values.mobile_number ? values.mobile_number : "",
          carrier_type: values.carrier_type ? values.carrier_type : "",
          address: values.address ? values.address : "",
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createCarrier(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/carrier");
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={CarrierDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <ShadowCard style={{ padding: 12 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 5, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4>
                      {carrier_guid ? "Update Carrier" : "Create Carrier"}
                    </Typography.h4>
                  </GridLayoutItem>
                  {/* carrier_name: string; city_id: number | null; state_id: number
                  | null; country_id: number | null; contact_person: string;
                  mobile_number: string; carrier_type: string; address: string; */}
                  <GridLayoutItem>
                    <Field
                      name="carrier_name"
                      label="Carrier"
                      placeholder="Carrier"
                      component={FormTextField}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      id={"city_id"}
                      name={"city_id"}
                      label={"City"}
                      placeholder="Select City"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={CityList?.map((city: ICity) => {
                        return {
                          value: city?.id,
                          label: city?.city_name,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"state_id"}
                      name={"state_id"}
                      label={"State"}
                      placeholder="Select State"
                      component={FormSelectionField}
                      disabled={true}
                      options={StateList?.map((state: IState) => {
                        return {
                          value: state?.id,
                          label: state?.state_name,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"country_id"}
                      name={"country_id"}
                      label={"Country"}
                      placeholder="Select Country"
                      component={FormSelectionField}
                      disabled={true}
                      options={CountryList?.map((country: ICountry) => {
                        return {
                          value: country?.id,
                          label: country?.country_name,
                        };
                      })}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="contact_person"
                      label="Contact Person"
                      placeholder="Contact Person"
                      astrike={true}
                      component={FormTextField}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="mobile_number"
                      label="Mobile No"
                      type="number"
                      placeholder="i.e. 9876543210"
                      max="10"
                      component={FormTextField}
                      //   astrike={true}
                      validator={MobileNoWOValueValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="address"
                      label="Address"
                      placeholder="address"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="carrier_type"
                      label="Carrier Type"
                      placeholder="Carrier Type"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`isactive`}
                      label="Status"
                      placeholder="Select Status"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={STATUSARRAY?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={3}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    <div>
                      <ButtonWithLoading
                        label={carrier_guid ? "Update" : "Create"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 4 }}
                        onClick={() => navigate("/carrier")}
                      >
                        Cancel
                      </Button>
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
              <CityChangeWatcher
                CityList={CityList}
                formRenderProps={formRenderProps}
              />
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateCarrier;
